import { combineEpics } from 'redux-observable';
import { createAccountEpic } from './create-account';
import { verifyAccountEpic } from './verify-account';
import { loginEpic } from './login';
import { logoutEpic } from './logout';
import { changePasswordEpic } from './change-password';
import { forgotPasswordEpic } from './forgot-password';
import { resendCodeEpic } from './resend-code';
import { resetAfterLogoutEpic } from './reset-after-logout';
import { authGuardEpic } from './auth-guard';
import { logoutAfterDeleteEpic } from './logout-after-delete';
import { googleLoginErrorEpic } from './google-login-error';
import { resetGoogleLoginErrorEpic } from './reset-google-login-error';
import { changeLoginEpic } from './change-login';
import { changeLoginSuccessEpic } from './change-login-success';
import { updateTokenDataEpic } from './update-token-data';

const authEpic = combineEpics(
  createAccountEpic,
  verifyAccountEpic,
  loginEpic,
  logoutEpic,
  changePasswordEpic,
  forgotPasswordEpic,
  resendCodeEpic,
  resetAfterLogoutEpic,
  authGuardEpic,
  logoutAfterDeleteEpic,
  googleLoginErrorEpic,
  resetGoogleLoginErrorEpic,
  changeLoginEpic,
  changeLoginSuccessEpic,
  updateTokenDataEpic
);

export default authEpic;
